import { useState } from "react";
import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarQuickFilter,
    GridToolbarExportContainer,
    GridPrintExportMenuItem,
    useGridApiContext,
} from "@mui/x-data-grid";
import { Box, MenuItem } from "@mui/material";

// Builds CSV from every row returned by the server (not just the current page),
// using the grid's visible columns so the output matches the built-in export.
const buildCsv = (apiRef, rows) => {
    const columns = apiRef.current
        .getVisibleColumns()
        .filter((col) => col.field !== "__check__" && !col.disableExport);

    const escape = (value) => {
        if (value === null || value === undefined) return "";
        const str = String(value);
        return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
    };

    const header = columns.map((col) => escape(col.headerName || col.field)).join(",");
    const body = rows.map((row) =>
        columns
            .map((col) => {
                let value = row[col.field];
                if (col.valueGetter) {
                    value = col.valueGetter({ id: row.id, field: col.field, row, value, colDef: col, api: apiRef.current });
                }
                if (col.valueFormatter) {
                    value = col.valueFormatter({ id: row.id, field: col.field, value, api: apiRef.current });
                }
                return escape(value);
            })
            .join(",")
    );
    return [header, ...body].join("\r\n");
};

const ExportAllCsvMenuItem = ({ exportAllRows, hideMenu }) => {
    const apiRef = useGridApiContext();
    const [downloading, setDownloading] = useState(false);

    const handleClick = async () => {
        setDownloading(true);
        try {
            const rows = await exportAllRows();
            const blob = new Blob([buildCsv(apiRef, rows || [])], { type: "text/csv;charset=utf-8" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${document.title || "export"}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        } finally {
            setDownloading(false);
            hideMenu?.();
        }
    };

    return (
        <MenuItem onClick={handleClick} disabled={downloading}>
            {downloading ? "Downloading..." : "Download as CSV"}
        </MenuItem>
    );
};

export default function CustomGridToolbar({ exportAllRows }) {
    return (
        <Box sx={{ backgroundColor: "grey.200" }}>
            <GridToolbarContainer
                sx={{ display: "flex", justifyContent: "space-between", p: 1 }}
            >
                <Box>
                    <GridToolbarColumnsButton />
                    {/* <GridToolbarFilterButton /> */}
                    {/* <GridToolbarDensitySelector /> */}
                    {exportAllRows ? (
                        <GridToolbarExportContainer>
                            <ExportAllCsvMenuItem exportAllRows={exportAllRows} />
                            <GridPrintExportMenuItem />
                        </GridToolbarExportContainer>
                    ) : (
                        <GridToolbarExport />
                    )}
                </Box>
                <Box>
                    <GridToolbarQuickFilter
                        className="grid-search"
                        sx={{
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: "grey.300",
                            borderRadius: "8px",
                            px: "12px",
                            py: "8px",
                        }}
                    />
                </Box>
            </GridToolbarContainer>
        </Box>
    );
}
